import tra from '../lang/translation.js'
import * as moment from 'moment'
export default class Helpers {
    FlashAlert(type, message) {
        // Implementation for flashing alert messages
        console.log(`%c FlashAlert [${type}] : ${message}`, 'color:lightgreen;')
        // get the flash alert id 
        let flashAlert = document.getElementById('flash-alert')
        // set the text content of the flash alert
        if (flashAlert) {
            flashAlert.textContent = message
            // set the class of the flash alert
            flashAlert.className = 'alert alert-' + type
            // show the flash alert
            flashAlert.style.display = 'block'
            // hide the flash alert after 3 seconds
            setTimeout(() => {
                flashAlert.style.display = 'none'
            }, 3000)
        }

    }
    setUrlToPaint(p) {
        // console.log('%c setUrltoPaint  . (1727456115) ', 'color:lightgreen;', p)
        // update the url
        // set url to be : /paintings/Natan-Shalva/' + p.token+ '/' + p.url_name
        // Update the URL in the browser
        const url = `/${this.l()}/${p.token}/paint/Natan-Shalva/${p.url_name}`
        console.log('%c url  . (1741511900) ', 'color:lightgreen;', url)
        history.pushState({}, '', url)
    }
    langs() {
        return ['en', 'fr', 'de']
    }
    t(v) {
        if (tra.en[v] == undefined) {
            return '--' + v + '--'
        }
        return tra['en'][v]
        //     if (location.pathname == '/' || location.pathname == '') {
        //         // no lang param in url - english by default
        //         if (tra.en[v] == undefined) {
        //             return '--'+v+'--'
        //         }
        //         return tra.en[v]
        //     }
        //     if (tra[location.pathname.split('/')[1]][v] == undefined) {
        //         return tra.en[v]
        //     }
        //    return tra[location.pathname.split('/')[1]][v]
    }
    l(v = null) {
        // get the lang param form url
        const lang = location.pathname.split('/')[1]
        if (v === null) {
            return lang ? lang : 'en'
        } else {
            // we need to add the v after the /
            return lang ? lang + '/' + v : 'en/' + v
        }
    }
    debug() {
        let debug = false
        // get the debug param form url 
        const urlParams = new URLSearchParams(window.location.search)
        if (urlParams.has('777')) {
            debug = true
        }
        return debug
    }
    // isAdmin() {
    //     let admin = false
    //     if (document.querySelector('meta[name="role"]')) {
    //         //@ts-ignore
    //         let role = document.querySelector('meta[name="role"]').content
    //         if (role > 25) {
    //             admin = true
    //         }
    //     }
    //     return admin
    // }
    pDate(d, diff = false) {
        if (diff) {
            return moment(d).format('DD.MM.YYYY') + ' | ' + moment(d).fromNow()
        }
        return moment(d).format('DD.MM.YYYY')
    }
    p_time(t) {
        return moment(t, 'HH:mm:ss').format('HH:mm')
    }
    isMobile() {
        const userAgent = navigator.userAgent || navigator.vendor || window.opera
        const isMobileDevice = /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent.toLowerCase())
        const isSmallScreen = window.innerWidth <= 768

        return isMobileDevice || isSmallScreen
    }

    getInitialPaintingCount() {
        return this.isMobile() ? 3 : 20
    }

    getPaintingsPerLoad() {
        return this.isMobile() ? 6 : 20
    }

}